import { Changeset, EmberChangeset } from "ember-changeset";

/**
 * This method creates a Changeset, and observes its changes
 * through the `afterValidation` hook to automatically save
 * its content (ie call `execute`).
 *
 * It takes the same parameters as the Changeset class.
 */
export default function (model) {
  const changeset = Changeset(model);
  changeset.on("afterValidation", () => {
    // Save the content of the changeset in the underlying object.
    changeset.execute();
  });
  return changeset;
}